<template>
  <CrudDataTable
    :con="con"
    :items="bookings"
    ref="dataTable"
    sortBy="dateStart"
    :hideBtn="true"
    :hideEdit="true"
    :canSearch="false"
    :canDelete="false"
  >
    <template v-slot:owner-name></template>
    <template v-slot:dialog-form="{ item }"> </template>

    <template v-slot:[`item.dateStart`]="{ item }">
      {{ formatDate(item.dateStart) }}
    </template>
    <template v-slot:[`item.dateEnd`]="{ item }">
      {{ formatDate(item.dateEnd) }}
    </template>
    <template v-slot:[`item.equipments`]="{ item }">
      <span
        v-if="
          (() => {
            a = listEquipments(item);
            return a.length >= 1;
          })()
        "
      >
        <v-chip outlined class="ma-1">
          {{ a[0] }}
        </v-chip>
      </span>
      <span v-else-if="a.length === 0">
        {{ $t("booking.none") }}
      </span>
      <span v-if="a.length > 1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="ma-1" icon x-small>
              <v-icon> mdi-dots-horizontal </v-icon>
            </v-btn>
          </template>
          <span>{{ a.slice(1).join(", ") }}</span>
        </v-tooltip>
      </span>
    </template>
    <template v-slot:[`item.reason`]="{ item }">
      {{ formatReason(item) }}
    </template>
    <template v-slot:[`item.complement`]="{ item }">
      {{ formatComplement(item) }}
    </template>

    <template v-slot:[`moreActions`]="{ item }">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon
            small
            @click="cancelBooking(item)"
            v-on="on"
            :disabled="item.cancelled"
          >
            mdi-book-cancel
          </v-icon>
        </template>
        <span>{{ $t("crudMyBookings.cancelBooking") }}</span>
      </v-tooltip>
    </template>
  </CrudDataTable>
</template>

<script>
import CrudDataTable from "@/components/components-salles/admin/crud/CrudDataTable.vue";
import CrudMyEquipmentBookingsTable from "@/models/crud/CrudMyEquipmentBookingsTable";
import BookingReasons from "@/models/BookingReasons";
import i18n from "@/i18n";

export default {
  name: "CrudMyEquipmentBookings",
  components: {
    CrudDataTable,
  },
  props: {
    bookings: null,
    showCancelled: null,
  },
  data: () => ({
    reasons: i18n.t("booking.purposes"),
  }),
  computed: {
    con() {
      const _con = {
        ...CrudMyEquipmentBookingsTable,
        crud: {
          indexOf: (item) => {
            return this.bookings.indexOf(item);
          },
        },
      };
      _con.locale.title = this.showCancelled
        ? _con.locale.titleCancelled
        : _con.locale.titleNotCancelled;
      return _con;
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    listResources(resources, type) {
      if (!resources.length) return [];
      const items = [];
      for (const resource of resources) {
        if (resource.type === type) items.push(resource.name);
      }
      if (!items.length) return [];
      return items.sort((a, b) => a.localeCompare(b));
    },
    listEquipments(item) {
      return this.listResources(item.resources, "equipment");
    },
    formatReason(item) {
      return this.reasons[BookingReasons.indexOf(item.reason)];
    },
    formatComplement(item) {
      return !item.complement || item.complement.length === 0
        ? i18n.t("booking.none")
        : item.complement;
    },
    cancelBooking(item) {
      this.$emit("cancelBooking", item);
    },
  },
};
</script>
